import { useCallback, useEffect, useState } from 'react';

export const useFooterConfig = (goPrev) => {
  const [footerConfig, setFooterConfig] = useState({
    message: 'Changes are auto-saved.',
    goBackHandler: () => {},
    actions: []
  });

  useEffect(() => {
    setFooterConfig((prev) => ({ ...prev, goBackHandler: goPrev }));
  }, [goPrev]);

  const updateConfigs = useCallback((values) => setFooterConfig(values), []);

  const addFooterActions = useCallback(
    (values) => setFooterConfig((prev) => ({ ...prev, actions: values })),
    []
  );

  return { footerConfig, setFooterConfig, updateConfigs, addFooterActions };
};
